import { useTypedQuery } from 'apiTyped/helpers/useTypedQuery';

export type Option = {
  label: string;
  value: number;
};

export type NetworkFilter = {
  countryId?: number;
};

export enum ProductType {
  Wine = 'wine',
  Spirit = 'spirit'
}

export type NotebookFilter = {
  network?: Option | null;
  country?: Option | null;
  market?: Option | null;
  year?: Option | null;
  subscribed?: boolean;
  productType: ProductType;
};

export const useMarkets = (networkFilter?: NetworkFilter) => {
  const { isLoading: isLoadingMarkets, data: marketResponse } = useTypedQuery(
    'get',
    '/notebooks/markets',
    {
      params: {
        query: {
          country_id: networkFilter?.countryId
        }
      }
    }
  );

  return { isLoadingMarkets, marketResponse };
};

export const useCountries = () => {
  const { isLoading: isLoadingCountries, data: countriesResponse } =
    useTypedQuery('get', '/notebooks/countries');

  return { isLoadingCountries, countriesResponse };
};

export const useNetworks = () => {
  const { isLoading: isLoadingNetworks, data: networksResponse } =
    useTypedQuery('get', '/common/networks');

  return { isLoadingNetworks, networksResponse };
};

export const useNotebooks = (filterValue: NotebookFilter) => {
  const { isLoading: isLoadingNotebooks, data: notebooksResponse } =
    useTypedQuery('get', '/notebooks/notebooks', {
      params: {
        query: {
          country_id: filterValue.country?.value,
          network_id: filterValue.network?.value,
          market_id: filterValue.market?.value,
          year: filterValue.year?.value,
          subscribed: filterValue.subscribed,
          spirit_survey:
            filterValue.productType == ProductType.Spirit ? true : false
        }
      }
    });

  return { isLoadingNotebooks, notebooksResponse };
};
